export default {
  namespaced: true,
  state: {
    resultDocuments: [], // 제출 완료 서류 목록
    confirmSMS: false,
    connectKey: null,
    connectAniNo: null,
  },
  mutations: {
    setResultDocuments(state, resultDocuments) {
      state.resultDocuments = resultDocuments;
    },
    setConfirmSMS(state, confirmSMS) {
      state.confirmSMS = confirmSMS;
    },
    setConnectKey(state, connectKey) {
      state.connectKey = connectKey;
    },
    setConnectAniNo(state, connectAniNo) {
      state.connectAniNo = connectAniNo;
    },
  },
  actions: {
    saveConfirmSMS({ commit }, confirmSMS) {
      commit("setConfirmSMS", confirmSMS);
    },
    saveConnectKey({ commit }, connectKey) {
      commit("setConnectKey", connectKey);
    },
    saveConnectAniNo({ commit }, connectAniNo) {
      commit("setConnectAniNo", connectAniNo);
    },
  },
  getters: {
    getResultDocuments(state) {
      return state.resultDocuments;
    },
    getConfirmSMS(state) {
      return state.confirmSMS;
    },
    getConnectKey(state) {
      return state.connectKey;
    },
    getConnectAniNo(state) {
      return state.connectAniNo;
    },
  }
};
